import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import {StudiewijzerlinkjesNewFacade} from '../../state/studiewijzerlinkjes/studiewijzerlinkjes.facade';

@Component({
    selector: 'app-studiewijzerlinkjes-detail-table-row-new',
    templateUrl: './studiewijzerlinkjes-detail-table-row-new.component.html',
    styleUrls: ['./studiewijzerlinkjes-detail-table-row-new.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class StudiewijzerlinkjesDetailTableRowNewComponent implements OnInit {

  constructor(store: StudiewijzerlinkjesNewFacade) { }

  ngOnInit(): void {
  }

}
